// extracted by mini-css-extract-plugin
export default {"container":"SweetsSection-module__container__awZCp","title":"SweetsSection-module__title__ai0qx","text":"SweetsSection-module__text__ROUvU"};